import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const addItemmaster = (itemid, itemname, description, serial_number,year, manufacturer,model,make,date_place,life_in_months,netbookvalue,originalcost,status,asset_id,item_type,category_id,
  sub_category_id) => {
    return axios.post(API + "contracts/create-itemmaster/", {
      itemid,
      itemname,
      description,
      serial_number,
      year,
      manufacturer,
      model,
      make,
      date_place,
      life_in_months,
      netbookvalue,
      originalcost,
      status,
      asset_id,
      item_type,
      category_id,
      sub_category_id
    },{headers: authHeader(),});
  };
  const AddItemmasterService = {
    addItemmaster,
      
    };
    export default AddItemmasterService;